import { useEffect } from "react";
import { useSelector } from "react-redux";
import { db, generateFirebaseId } from "senf-shared";
import { collection, addDoc } from "firebase/firestore/lite";

const useUtmVisitor = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utm_id = urlParams.get("utm_id");
  const project = useSelector((state) => state.data.project);
  const { consent_settings } = useSelector((state) => state.data);

  const initializeUtmVisitor = async () => {
    let visitorId = localStorage.getItem("visitorId");

    if (!visitorId) {
      visitorId = generateFirebaseId(28);
      localStorage.setItem("visitorId", visitorId);
    }

    if (project?.projectId) {
      localStorage.setItem("projectId", project.projectId);
    }

    if (utm_id) {
      localStorage.setItem("utm_id", utm_id);
    }

    try {
      await addDoc(
        collection(
          db,
          `organizations/${project.organizationId}/projects/${project.projectId}/visits`
        ),
        {
          visitorId,
          utm_id: utm_id || localStorage.getItem("utm_id") || null,
          projectId: project?.projectId,
          createdAt: new Date().toISOString(),
          url: window.location.href,
        }
      );
    } catch (e) {}
  };

  useEffect(() => {
    if (project?.projectId) {
      initializeUtmVisitor();
    }
  }, [project?.projectId]);
};

export default useUtmVisitor;
